import React from 'react'
import { useIntl } from 'react-intl'
import { useData } from 'vike-react/useData'

import { SectionFAQ } from '../../components/SectionFAQ'
import { SlitePage } from '../../components/SlitePage'
import { useRoutes } from '../../routes'
import { SectionHomeSocialProof } from '../home/SectionHomeSocialProof'
import type { Data } from './+data'
import { getAgentFAQ } from './data'
import { SectionAgentHowItWorks } from './HowItWorks/SectionAgentHowItWorks'
import { SectionAgentBuiltIn } from './SectionAgentBuiltIn'
import { SectionAgentHero } from './SectionAgentHero'
import { SectionAgentInterfaces } from './SectionAgentInterfaces'
import { SectionAgentSolutions } from './SectionAgentSolutions'

export default function AgentPage() {
  const intl = useIntl()
  const routes = useRoutes()
  const { solutions } = useData<Data>()

  const pageTitle = intl.formatMessage({
    id: 'agent.helmet.title',
    defaultMessage: 'Slite Agent — Your AI agent for trusted company knowledge',
  })
  const pageDescription = intl.formatMessage({
    id: 'agent.helmet.description',
    defaultMessage:
      'Scale AI across your company with Slite agent that delivers trusted answers, drafts documentation and proposes updates for your team to approve.',
  })

  return (
    <SlitePage
      title={pageTitle}
      description={pageDescription}
      canonicalUrl={routes.agent()}
      background="moon-dust-lighter"
    >
      <SectionAgentHero />
      <SectionAgentBuiltIn />
      <SectionAgentHowItWorks />
      <SectionAgentInterfaces />
      {solutions.length > 0 && <SectionAgentSolutions solutions={solutions} />}
      <SectionHomeSocialProof />
      <SectionFAQ faq={getAgentFAQ(intl)} />
    </SlitePage>
  )
}
